export default __webpack_public_path__ + "static/media/logo-dark.593702c0.png";